/**
 * @file components/PublicFooter.js
 * @description Simple footer for public (logged-out) marketing pages.
 */
import React from 'react';
import { Link } from 'react-router-dom';

function PublicFooter() {
  const linkStyle = {
    color: '#4B5563',
    textDecoration: 'none',
    fontSize: '0.875rem',
  };

  return (
    <footer
      style={{
        borderTop: '1px solid #E5E7EB',
        marginTop: '4rem',
        padding: '2rem 1.5rem 3rem',
        backgroundColor: '#FAFAFA',
        color: '#6B7280',
        textAlign: 'center',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          gap: '1.5rem',
          marginBottom: '1rem',
        }}
      >
        <Link to="/features" style={linkStyle}>Features</Link>
        <Link to="/pricing" style={linkStyle}>Pricing</Link>
        <Link to="/build-log" style={linkStyle}>Build Log</Link>
        <Link to="/terms" style={linkStyle}>Terms</Link>
        <a href="mailto:james@wncil.com" style={linkStyle}>Contact</a>
      </div>
      <p style={{ fontSize: '0.8125rem', color: '#9CA3AF', margin: 0 }}>
        © {new Date().getFullYear()} Inspection Butler. Built in Western NC.
      </p>
    </footer>
  );
}

export default PublicFooter;
